var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstitution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512.018 512.018",
    viewBox: "0 0 512.018 512.018",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m492.009 217.342c11.046 0 20-8.954 20-20v-58.666c0-7.56-4.262-14.473-11.015-17.868l-236-118.667c-5.653-2.842-12.316-2.842-17.97 0l-236 118.667c-6.753 3.396-11.015 10.309-11.015 17.868v58.666c0 11.046 8.954 20 20 20h18.667v176.056c-8.58.57-15.906 6.584-18.05 15.016l-20 78.667c-3.21 12.625 6.34 24.928 19.383 24.928h472c13.027 0 22.597-12.288 19.383-24.928l-20-78.667c-2.199-8.649-9.852-14.75-18.717-15.044v-176.028zm-452-66.337 216-108.61 216 108.61v26.337h-432zm137.333 242.337v-176h156.667v176zm-40-176v176h-58.667v-176zm-91.613 254.667 9.831-38.667h400.897l9.831 38.667zm386.946-78.667h-58.667v-176h58.667z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/Institution.513cee1f.svg";
export { ForwardRef as ReactComponent };